exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-location-index-js": () => import("./../../../src/templates/Location/index.js" /* webpackChunkName: "component---src-templates-location-index-js" */)
}

